document.addEventListener("turbolinks:load", function (e) {
    $('input[name="seminar[free]"]').change(function () {
        if ($(this).val() === 'true') {
            $('#seminar_price_wrapper').hide();
        } else {
            $('#seminar_price_wrapper').show();
        }
    })

    if ($('.seminar_form').length > 0) {
        $('[data-toggle="popover"]').popover({
            // trigger: 'focus'
        })
    }

    $('input[name="seminar[has_video_term]"]').change(function () {
        if ($(this).val() === 'true') {
            $('#video_term').show();
        } else {
            $('#video_term').hide();
        }
    })

    $('input[name="seminar[send_custom_email]"]').change(function () {
        if ($(this).prop('checked')) {
            $('#send_custom_email_form').show('fast');
        } else {
            $('#send_custom_email_form').hide('fast');
        }
    })
});